module.exports = __webpack_public_path__ + "static/img/resume-cool-rtl2.196de27.png";